export enum ShopTypeEnum {
    Other = 1,
    BigCommerce = 2,
    Shopify = 3,
    WooCommerce = 4,
    Ebay = 5,
    PrestaShop = 6,
    Wix = 7,
    Lightspeed = 8,
    Visualsoft=9,
    LightspeedX = 10,
    Loyverse = 11,
    Magento = 12
}